<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">Autentification credentials</h3>
  </div>

  <!---------- main content ---------->

  <div class="dialog-content__container">
    <form [formGroup]="credentialsForm">
      <div class="row">
        <div class="row col-6">
          <div class="form__item mb-3">
            <label class="label-input col-sm-5">Login bank</label>
            <div class="col-sm-3">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="login"
              />
            </div>
          </div>
          <div class="form__item mb-3">
            <label class="label-input col-sm-5">Password file path</label>
            <div class="col-sm-5">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="passwordFilePath"
              />
            </div>
            <span
              class="button button__lightblue credentials__copy"
              *ngIf="credentialsForm.controls['passwordFilePath'].value"
              (click)="
                copyToClipboard(
                  credentialsForm.controls['passwordFilePath'].value
                )
              "
              >Copy</span
            >
          </div>
          <div class="form__item mb-3">
            <label class="label-input col-sm-5">Key file path</label>
            <div class="col-sm-5">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="keyFilePath"
              />
            </div>
            <span
              class="button button__lightblue credentials__copy"
              *ngIf="credentialsForm.controls['keyFilePath'].value"
              (click)="
                copyToClipboard(credentialsForm.controls['keyFilePath'].value)
              "
              >Copy</span
            >
          </div>
          <div class="form__item mb-3">
            <label class="label-input col-sm-5"
              >Backup password file path</label
            >
            <div class="col-sm-5">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="backupPasswordFilePath"
              />
            </div>
            <span
              class="button button__lightblue credentials__copy"
              *ngIf="credentialsForm.controls['backupPasswordFilePath'].value"
              (click)="
                copyToClipboard(
                  credentialsForm.controls['backupPasswordFilePath'].value
                )
              "
              >Copy</span
            >
          </div>
        </div>
        <div class="row col-6">
          <div class="form__item mb-3">
            <label class="label-input col-sm-5">Backup key file path</label>
            <div class="col-sm-5">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="backupKeyFilePath"
              />
            </div>
            <span
              class="button button__lightblue credentials__copy"
              *ngIf="credentialsForm.controls['backupKeyFilePath'].value"
              (click)="
                copyToClipboard(
                  credentialsForm.controls['backupKeyFilePath'].value
                )
              "
              >Copy</span
            >
          </div>
          <div class="form__item mb-3">
            <label class="label-input col-sm-5">Cloud password file path</label>
            <div class="col-sm-5">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="cloudPasswordFilePath"
              />
            </div>
            <span
              class="button button__lightblue credentials__copy"
              *ngIf="credentialsForm.controls['cloudPasswordFilePath'].value"
              (click)="
                copyToClipboard(
                  credentialsForm.controls['cloudPasswordFilePath'].value
                )
              "
              >Copy</span
            >
          </div>
          <div class="form__item mb-3">
            <label class="label-input col-sm-5">Cloud key file path</label>
            <div class="col-sm-5">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="cloudKeyFilePath"
              />
            </div>
            <span
              class="button button__lightblue credentials__copy"
              *ngIf="credentialsForm.controls['cloudKeyFilePath'].value"
              (click)="
                copyToClipboard(
                  credentialsForm.controls['cloudKeyFilePath'].value
                )
              "
              >Copy</span
            >
          </div>
          <div class="form__item mb-3">
            <label class="label-input col-sm-5">Comment</label>
            <div class="col-sm-3">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="comment"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!--  save/cancel buttons -->
  <div class="row justify-content-end dialog-button__container pt-3">
    <div class="col-auto p-0">
      <button class="button button__save add-margin" (click)="save()">
        Save
      </button>
      <button class="button button__cancel" (click)="close()">Cancel</button>
    </div>
  </div>

  <img
    class="interview__trash icon"
    src="assets/icons/svg/trash/ion_trash-bin.svg"
    alt="trash"
    *ngIf="!isCreate"
    (click)="deleteCredential()"
  />
</div>
